const { $ } = window;

/**
 * @usage tmpl(
 *      'hello {{ name }}!',
 *      { name: 'ash' }
 * );
 * => hello ash!
 *
 * @param {any} str
 * @param {any} data
 * @returns
 */
export function tmpl(pStr, pData) {
  let reg;
  let str = pStr;
  Object.keys(pData).forEach((item) => {
    reg = new RegExp(`{{ ${item} }}`, 'g');
    str = str.replace(reg, pData[item]);
  });
  return str;
}
export function getQueryString(pKey) {
  if (typeof pKey !== 'string' || !pKey) {
    console.error('Invalid parameter key.');
    return null;
  }

  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(pKey);
}

function initSetVCode($img) {
  $img.attr('src', `api/vcode.ashx?rnd=${Math.round(Math.random() * 999999)}`);
}

export function setVCode($img) {
  initSetVCode($img);
  $img.on('click', function click() {
    initSetVCode($(this));
  });
}

export function padLeft(str, lenght) {
  if (str.toString().length >= lenght) {
    return str;
  }
  return padLeft(`0${str}`, lenght);
}

// loading樣式
export function loadingView() {
  return '<div class="fetch-loading">'
                  + '<div class="spinner" role="status"><i class="icon icon-reload"></i> <span'
                          + ' class="sr-only">Loading...</span></div>'
              + '</div>';
}

export function setGA(id) {
  if (window.dataLayer !== undefined) {
    window.dataLayer.push({
      event: 'userID',
      event_userID: id,
    });
  }
}

export default {
  tmpl,
  getQueryString,
  setVCode,
  padLeft,
  loadingView,
  setGA,
};
